/**
 * Aplica las posiciones de los 11 hotspots del player al DOM.
 *
 * Cada hotspot tiene un `id` HTML y un `key` lógico en `state.hotspots`.
 * `applyAllHotspots()` se llama al montar y después de cada edición.
 *
 * En Fase 4c el editor permitirá arrastrarlos y se guardarán en
 * localStorage; persistence ya lo soporta desde Fase 4a.
 */

import { state } from './state.js';
import type { HotspotId } from './types.js';

/** Mapeo entre el id del DOM y el key lógico del hotspot en state. */
const HOTSPOT_MAP: ReadonlyArray<[string, HotspotId]> = [
  ['r-hs-rec', 'rec'],
  ['r-hs-play', 'play'],
  ['r-hs-rew', 'rew'],
  ['r-hs-ff', 'ff'],
  ['r-hs-stop', 'stop'],
  ['r-hs-pause', 'pause'],
  ['r-led', 'led'],
  ['r-led-play', 'led_play'],
  ['r-reel-l', 'reel_l'],
  ['r-reel-r', 'reel_r'],
  ['r-knob', 'knob'],
];

/** Aplica un hotspot concreto leyendo su rect actual de `state.hotspots`. */
export function applyHotspot(elId: string, key: HotspotId): void {
  const el = document.getElementById(elId);
  const h = state.hotspots[key];
  if (!el || !h) return;
  el.style.left = h.left + '%';
  el.style.top = h.top + '%';
  el.style.width = h.width + '%';
  el.style.height = h.height + '%';
}

/** Aplica los 11 hotspots de una vez. */
export function applyAllHotspots(): void {
  for (const [elId, key] of HOTSPOT_MAP) {
    applyHotspot(elId, key);
  }
}

/** Devuelve el mapeo (útil para el editor en Fase 4c). */
export function getHotspotMap(): ReadonlyArray<[string, HotspotId]> {
  return HOTSPOT_MAP;
}
